module.exports = __webpack_public_path__ + "media/unipod/eight_step6-155953d7.jpg";